import { AxProject } from './AxProject';

export interface IAxCustomer {
    /**
     * Full name of the customer
     */
    customerName: string;
    /**
     * Customer number
     */
    customerNumber: string;
    /**
     * A list of contacts for the customer.
     * No data for this vailable yet?
     * TODO: check if we have an etrys with data for that
     */
    contacts?: any[];
    /**
     * A list of projects from the customer
     */
    projects: AxProject[];
}

export class AxCustomer implements IAxCustomer {
    public customerName: string;
    public customerNumber: string;
    public contacts?: any[];
    public projects: AxProject[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IAxCustomer);
    constructor(obj?: any) {
        this.customerName = obj && obj.customerName || '';
        this.customerNumber = obj && obj.customerNumber || '';
        this.projects = [];
        if (obj && obj.projects !== undefined) {
            obj.projects.forEach((projects: AxProject) => {
                this.projects.push(new AxProject(projects));
            });
        }
    }
}
